import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/** 라우트 변경 시 자동 페이지 최상단 스크롤. 해시(#section) 링크는 해당 앵커로 스크롤.
 *  lazy-loaded 페이지는 chunk fetch + render 지연이 있어 단발 setTimeout 으로는
 *  element 가 아직 없을 수 있음 → 최대 ~2초간 polling 으로 재시도. */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '')
      let cancelled = false
      let tries = 0
      const tryScroll = () => {
        if (cancelled) return
        const el = document.getElementById(id)
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' })
          return
        }
        if (tries++ < 20) setTimeout(tryScroll, 100)
      }
      tryScroll()
      return () => { cancelled = true }
    }
    // 대시보드는 AppShell <main id="main-content"> 가 자체 스크롤 컨테이너 → window 스크롤만
    // 리셋하면 라우트 이동 시 이전 페이지 스크롤 위치가 그대로 남는다. 두 곳 모두 0 으로.
    window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior })
    const main = document.getElementById('main-content')
    if (main) main.scrollTop = 0
  }, [pathname, hash])

  return null
}
